"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
const React = require("react");
const react_redux_1 = require("react-redux");
const react_bootstrap_1 = require("react-bootstrap");
const LandingStore_1 = require("../../LandingStore");
const LandingActions_1 = require("../../LandingActions");
const emailPanel_1 = require("../../emailPanel/emailPanel");
const mapDispatchToProps = dispatch => {
    return {
        openModal: modal => dispatch(LandingActions_1.openModal(modal))
    };
};
class HeaderPartComponent extends React.Component {
    render() {
        return React.createElement(react_bootstrap_1.Row, { className: "why-header-component" }, React.createElement(react_bootstrap_1.Col, { xs: 12, md: 12, sm: 12, className: "header-component-text text-left" }, React.createElement("div", { className: "hero-header" }, React.createElement("h1", null, "Why Us"), React.createElement("h2", { className: "thinText" }, "We listen to you and your customers  ", React.createElement("br", null), "We will continuously be at the edge of innovation"))), React.createElement(react_bootstrap_1.Col, { xs: 6, md: 6, sm: 6 }, React.createElement(react_bootstrap_1.Image, { className: "video-player pointer", src: "../img/video_player.png", onClick: () => {
                this.props.openModal(LandingStore_1.LandingModal.Video);document.body.scrollTop = 0;
            } })), React.createElement(react_bootstrap_1.Col, { xs: 12, md: 12, sm: 12 }, React.createElement(emailPanel_1.default, null)));
    }
}
const HeaderPart = react_redux_1.connect(null, mapDispatchToProps)(HeaderPartComponent);
exports.default = HeaderPart;


//////////////////
// WEBPACK FOOTER
// ./client/src/landing/whyUs/components/HeaderPart.tsx
// module id = 1095
// module chunks = 0 1